module.exports = __webpack_public_path__ + "img/marius.fbb3375f.jpg";